import { z } from "zod";
import { dmaIngredientDtoSchema } from "../dma-domain";
import { dmaRequestedMiniModelDtoSchema } from "../dma-requested-mini-model/dma-requested-mini-model.schema";
import { dmaSettingDtoSchema } from "../dma-setting/dma-setting.schema";
export const dmaFormulationDtoSchema = z.object({
    ingredients: z.array(dmaIngredientDtoSchema),
    settings: z.array(dmaSettingDtoSchema),
    requestedMiniModels: z.array(dmaRequestedMiniModelDtoSchema),
});
